const stripHTML = (htmlCode) => htmlCode.replace(/<[^>]+>/g, '');

export default stripHTML;
